import React from "react";
import Layout from "./src/components/layout";
import "./src/styles/global.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const wrapRootElement = ({ element }) => {
  return <Layout>{element}</Layout>;
};
